export default "__VITE_ASSET__PBNVwjt$__"